import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import {KEYWORD_TYPE} from "../@constants";


const TABS = [
	{label: 'Keywords Types', value: KEYWORD_TYPE.KEYWORD_TYPE},
	{label: 'Branded Keywords', value: KEYWORD_TYPE.KEYWORD_BRAND},
	{label: 'Keywords Categories', value: KEYWORD_TYPE.KEYWORD_CATEGORY},
]

export default function ShareOfSearchKpiTabs({ value, onChange }) {
    return <TabsSeeker
		tabs={TABS}
		value={value}
		onChange={onChange}
	/>
}